const DEFAULT_VERSION = '0000000';

function getAndroidVersion(UA) {
  // new format example: BLAndroid/4045200 blbeta Dalvik/2.1.0 (Linux; U; Android 6.0.1; vivo 1610 Build/MMB29M)
  // old format example:  Dalvik/2.1.0 (Linux; U; Android 7.0; Android SDK built for x86 Build/NYC) 4045200 BLAndroid blbeta

  let newFormat = UA.match(/blandroid\/\d{7}/i);
  newFormat = newFormat ? newFormat[0].split('/')[1] : newFormat;

  let oldFormat = UA.match(/\d{7}(?= blandroid)/i);
  oldFormat = oldFormat ? oldFormat[0] : oldFormat;

  return newFormat || oldFormat || DEFAULT_VERSION;
}

function getIOsVersion(UA) {
  // new format example:  BLiOS/0240000 blbeta iPhone5,2 iOS/10_1 CFNetwork/808.3 Darwin/16.3.0
  // old format example:  blios BLMobile/0240000 blbeta

  let newFormat = UA.match(/blios\/\d{7}/i);
  newFormat = newFormat ? newFormat[0].split('/')[1] : newFormat;

  let oldFormat = UA.match(/blmobile\/\d{7}/i);
  oldFormat = oldFormat ? oldFormat[0].split('/')[1] : oldFormat;

  return newFormat || oldFormat || DEFAULT_VERSION;
}

function getMitraAndroidVersion(UA) {
  // example: Dalvik/2.1.0 (Linux; U; Android 8.0.0; Google Nexus 5X Build/OPR6.170623.017) 1029002 BLMitraAndroid
  // with dailiy/nightly build example: Dalvik/2.1.0 (Linux; U; Android 8.0.0; Google Nexus 5X Build/OPR6.170623.017) 1029034602 BLMitraAndroid
  let version = UA.match(/\d{7,10} blmitraandroid/i);
  version = version ? version[0].split(' ')[0].substring(0, 7) : version;

  return version || DEFAULT_VERSION;
}

export function getAppVersion(UA) {
  const isAndroid = UA.match(/blandroid/i);
  const isIOs = UA.match(/blios/i);
  const isMitraAndroid = UA.match(/blmitraandroid/i);

  if (isAndroid) {
    return Number(getAndroidVersion(UA));
  }
  if (isIOs) {
    return Number(getIOsVersion(UA));
  }
  if (isMitraAndroid) {
    return Number(getMitraAndroidVersion(UA));
  }
  return Number(DEFAULT_VERSION);
}

/* istanbul ignore next */
export const USER_AGENT = (global && global.navigator && global.navigator.userAgent) || '';
export const APP_VERSION = getAppVersion(USER_AGENT);
export const IS_BL_APP = /(blandroid|blios)/i.test(USER_AGENT);

export const IS_IOS = /blios/i.test(USER_AGENT);
export const IS_ANDROID = /blandroid/i.test(USER_AGENT);
export const IS_MITRA_ANDROID = /blmitraandroid/i.test(USER_AGENT);

export const IS_ANDROID_DEVICE = /android/i.test(USER_AGENT);

export default {};
